import {
  Box,
  Circle,
  Flex,
  Text,
  Grid,
  Textarea,
  Spacer,
  Button,
  FormLabel,
  IconButton,
} from "@chakra-ui/react";
import { Fragment, useEffect, useState } from "react";
import { useProfile } from "@/contexts/ProfileContext";
import { useEditProfileContext } from "./edit/shared";
import { DeleteIcon, AddIcon } from "@chakra-ui/icons";

const ECList = () => {
  const { profile } = useProfile();
  return (
    <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} alignSelf="stretch" gap={5}>
      {profile.ecs.map(({ organization, description, position }, i) => (
        <Box key={i}>
          <Flex gap={4} alignItems="center" fontWeight="bold">
            <Circle bg="red.200" fontFamily="heading" fontSize="3xl" px={4} py={1}>
              {i + 1}
            </Circle>
            <Box>
              <Text fontSize="2xl">{organization}</Text>
              <Text fontSize={!organization ? "2xl" : "lg"}>{position}</Text>
            </Box>
          </Flex>
          <Text fontSize="lg">{description}</Text>
        </Box>
      ))}
    </Grid>
  );
};

export const EditableECList = () => {
  const { initialProfileData, update } = useEditProfileContext();
  const [ecs, setECs] = useState(initialProfileData.ecs);

  useEffect(() => update("ecs", ecs), [ecs]);

  return (
    <Box mt={4}>
      <Flex>
        <Spacer />
        <Button
          colorScheme="green"
          leftIcon={<AddIcon />}
          my={4}
          isDisabled={ecs.length >= 10}
          onClick={() => {
            setECs([...ecs, { position: "", organization: "", description: "" }]);
          }}
        >
          Add Activity
        </Button>
      </Flex>
      {ecs.length > 0 && (
        <Grid templateColumns="1fr 2fr 2fr 7fr 1fr" rowGap={2} columnGap={1} alignItems="center">
          <Box />
          <FormLabel fontSize="xl">Position</FormLabel>
          <FormLabel fontSize="xl">Organization</FormLabel>
          <FormLabel fontSize="xl">Description</FormLabel>
          <Box />
          {ecs.map(({ position, organization, description }, i) => {
            const onUpdateField = (fieldName, value) => {
              const newECs = [...ecs];
              newECs[i][fieldName] = value;
              setECs(newECs);
            };
            const onDelete = () => {
              const newECs = [...ecs];
              newECs.splice(i, 1);
              setECs(newECs);
            };

            return (
              <Fragment key={i}>
                <Text fontSize="2xl" justifySelf="end" pr={4}>
                  <sup>#</sup>
                  {i + 1}
                </Text>
                <Textarea
                  value={position}
                  fontWeight="bold"
                  placeholder="Position"
                  padding={1}
                  fontSize="sm"
                  onChange={(e) => onUpdateField("position", e.target.value)}
                />
                <Textarea
                  value={organization}
                  placeholder="Organization"
                  padding={1}
                  fontWeight="bold"
                  fontSize="sm"
                  onChange={(e) => onUpdateField("organization", e.target.value)}
                />
                <Textarea
                  value={description}
                  placeholder="Description"
                  padding={1}
                  fontSize="sm"
                  onChange={(e) => onUpdateField("description", e.target.value)}
                />
                <IconButton
                  colorScheme="red"
                  variant="ghost"
                  icon={<DeleteIcon />}
                  onClick={onDelete}
                />
              </Fragment>
            );
          })}
        </Grid>
      )}
    </Box>
  );
};

export default ECList;
